import React, { useState } from 'react';

import { Button, Flex, SimpleGrid, Stack } from '@mantine/core';
import { IconPencil, IconWand } from '@tabler/icons-react';
import { DroxySelectCard } from 'components/Droxy/DroxySelectCard';
import { t } from 'i18next';
import { EvaluationModalView } from 'pages/ManageSmartAssistant/Sections/EvaluationsSection/EvaluationModal/CreateEvaluationModal';

export type EvaluationCreationType = 'manual' | 'wizard';

interface EvaluationModalSelectViewProps {
  setModalView: (view: EvaluationModalView) => void;
  onClose: () => void;
}

export function EvaluationModalSelectView({ setModalView, onClose }: EvaluationModalSelectViewProps) {
  const [selectedCreationType, setSelectedCreationType] = useState<EvaluationCreationType>('wizard');

  const handleContinue = () => {
    if (selectedCreationType === 'wizard') {
      setModalView('generate');
    } else {
      setModalView('preview');
    }
  };

  return (
    <Stack spacing={24}>
      <SimpleGrid cols={2}>
        <DroxySelectCard
          title={t('SMART_ASSISTANT.EVALUATIONS_SECTION.WIZARD_SELECT_CARD.TITLE')}
          description={t('SMART_ASSISTANT.EVALUATIONS_SECTION.WIZARD_SELECT_CARD.DESCRIPTION')}
          icon={<IconWand />}
          isSelected={selectedCreationType === 'wizard'}
          onSelect={() => setSelectedCreationType('wizard')}
        />

        <DroxySelectCard
          title={t('SMART_ASSISTANT.EVALUATIONS_SECTION.MANUAL_SELECT_CARD.TITLE')}
          description={t('SMART_ASSISTANT.EVALUATIONS_SECTION.MANUAL_SELECT_CARD.DESCRIPTION')}
          icon={<IconPencil />}
          isSelected={selectedCreationType === 'manual'}
          onSelect={() => setSelectedCreationType('manual')}
        />
      </SimpleGrid>

      <Flex gap={16} justify="flex-end">
        <Button variant="outline" onClick={onClose}>
          {t('APP.ACTIONS.CANCEL')}
        </Button>
        <Button onClick={handleContinue}>{t('APP.ACTIONS.CONTINUE')}</Button>
      </Flex>
    </Stack>
  );
}
